export const netherlands = {
  slug: "netherlands",
  name: "Netherlands",
  flag: "🇳🇱",
  tagline: "Innovation, English Education & European Opportunity",
  heroImg: "https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#F36C21",
  students: "45+",
  avgTuition: "€8,000–€18,000/yr",
  avgLiving: "€900–€1,400/mo",
  workPermit: "1 year Orientation Visa",
  ieltsReq: "6.0–6.5",
  intakeMonths: ["September", "February"],
  overview:
    "The Netherlands is one of Europe’s top destinations for international students with 2,000+ English-taught programmes, globally ranked universities, and strong career opportunities in technology, logistics, and business.",
  whyChoose: [
    { icon: "🎓", title: "English-Taught Degrees", desc: "One of Europe’s highest numbers of English programmes at bachelor’s and master’s level." },
    { icon: "💼", title: "Strong Job Market", desc: "Excellent opportunities in IT, engineering, finance, and sustainability sectors." },
    { icon: "🌍", title: "International Hub", desc: "Highly multicultural environment with students from 160+ countries." },
    { icon: "📋", title: "Orientation Year Visa", desc: "Stay 1 year after graduation to find a skilled job in the Netherlands." },
    { icon: "🚲", title: "High Quality of Life", desc: "Safe cities, cycling culture, efficient transport, and balanced lifestyle." },
    { icon: "🤝", title: "PR Pathway", desc: "Long-term residence opportunities after skilled employment." },
  ],
  process: [
    { step: "01", title: "Choose Programme", desc: "Select research university or university of applied sciences based on career goals." },
    { step: "02", title: "Apply Online", desc: "Submit applications through Studielink or university portals." },
    { step: "03", title: "Visa & Residence Permit", desc: "University assists with MVV visa and residence permit process." },
    { step: "04", title: "Travel & Registration", desc: "Arrive, register with municipality, collect residence card." },
  ],
  universities: [
    "tu-delft","uva","erasmus-rotterdam","leiden","utwente",
    "wageningen","radboud","groningen","vu-amsterdam","eindhoven-tu"
  ],
  stats: [
    { n: "45+", label: "Students Placed" },
    { n: "€8k", label: "Min Tuition/yr" },
    { n: "94%", label: "Visa Success" },
    { n: "1yr", label: "Post-Study Permit" },
  ],
};